import styled from "styled-components";

export const Flex = styled.div`
  display: flex;
  flex-wrap: wrap;
  ${({ singleColumn }) =>
    singleColumn &&
    `max-width: 600px;
      margin: auto;`};
`;

export const FlexSection = styled.section`
  margin-bottom: 20px;
  flex: 1 0 100%;
  @media (min-width: 600px) {
    margin-bottom: 40px;
    padding: 0 20px;
  }
  @media (min-width: 800px) {
    flex: 1 1 50%;
    :first-child {
      padding-left: 0;
    }
    :last-child {
      padding-right: 0;
    }
  }
  ${({ singleColumn }) => singleColumn && `flex: 1 0 100% !important;`};
`;
